export default __webpack_public_path__ + "static/media/song4_img.bbef88ad.jpg";